import { useState } from "react";

export interface IPaginationState {
  count: number;
  limit: number;
  page: number;
  setCount: (count: number) => void;
  setLimit: (limit: number) => void;
  setPage: (page: number) => void;
}

const usePagination = (newLimit = 20, currentPage = 0): IPaginationState => {
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(newLimit);
  const [page, setPage] = useState(currentPage);

  return {
    count,
    limit,
    page,
    setCount,
    setLimit,
    setPage,
  };
};

export default usePagination;
